module.exports = "/_next/static/images/ipad_coins_sort-d3ba0d1439bd7691cf4e7e8998160b90.png";